module.exports = __webpack_public_path__ + "img/p6.5e02338b.png";